"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapLegend = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var React = _interopRequireWildcard(require("react"));

var _react2 = require("@emotion/react");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["float: right; margin-left: 16px;"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["margin-right: 4px;"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: #1f4e46;\n  font-family: 'Montserrat', sans-serif;\n  font-size: .75rem;\n  font-weight: 700;\n  margin-bottom: 16px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  align-items: flex-start;\n  color: #1f4e46;\n  font-family: 'Montserrat', sans-serif;\n  font-size: .75rem;\n  font-weight: 300;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0;\n  margin: 0;\n  list-style: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: rgba(255,255,255,0.8);\n  max-width: 168px;\n  min-height: 20px;\n  padding: 5px 15px;\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  width: 168px;\n  z-index: 10;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var legendWrapperStyle = (0, _react2.css)(_templateObject());
var legendListStyle = (0, _react2.css)(_templateObject2());
var legendEntryStyle = (0, _react2.css)(_templateObject3());
var legendTitleStyle = (0, _react2.css)(_templateObject4());

function setLegend(legendEntries, colorScale) {
  return legendEntries.map(function (entry, i) {
    return (0, _react2.jsx)("li", {
      key: entry,
      css: legendEntryStyle
    }, (0, _react2.jsx)("svg", {
      width: "21",
      height: "20",
      css: (0, _react2.css)(_templateObject5())
    }, (0, _react2.jsx)("rect", {
      x: "2",
      y: "2",
      width: "16",
      height: "16",
      fill: colorScale[i],
      stroke: "black"
    })), (0, _react2.jsx)("span", {
      className: "map-legend__entry"
    }, entry));
  });
}

var MapLegend = function MapLegend(_ref) {
  var legendEntries = _ref.legendEntries,
      colorScale = _ref.colorScale,
      title = _ref.title,
      children = _ref.children;

  var _React$useState = React.useState(true),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isExpanded = _React$useState2[0],
      setExpansion = _React$useState2[1];

  return (0, _react2.jsx)("div", {
    css: legendWrapperStyle
  }, isExpanded ? (0, _react2.jsx)(React.Fragment, null, (0, _react2.jsx)("span", {
    css: legendTitleStyle
  }, title), (0, _react2.jsx)("ul", {
    css: legendListStyle
  }, setLegend(legendEntries, colorScale)), children) : (0, _react2.jsx)("span", {
    css: legendTitleStyle
  }, "Expand Legend"), (0, _react2.jsx)("button", {
    type: "button",
    css: (0, _react2.css)(_templateObject6()),
    onClick: function onClick() {
      return setExpansion(!isExpanded);
    }
  }, isExpanded ? '-' : '+'));
};

exports.MapLegend = MapLegend;